import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getAllFlightItinerariesApi } from './getAllFlightItineraries.api'
import getAllFlightItinerariesInitialState from './getAllFlightItineraries.initialState'
import {
  GetAllFlightItinerariesErrorResponse,
  GetAllFlightItinerariesRequestPayload
} from './getAllFlightItineraries.types'

export const getAllFlightItineraries = createAsyncThunk(
  urls.flights.getAllFlightItineraries,
  async (payload: GetAllFlightItinerariesRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getAllFlightItinerariesApi(request)

      onSuccess && onSuccess(response)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getAllFlightItinerariesSlice = createSlice({
  name: urls.flights.getAllFlightItineraries,
  initialState: getAllFlightItinerariesInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllFlightItineraries.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getAllFlightItineraries.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getAllFlightItineraries.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetAllFlightItinerariesErrorResponse
        state.success = null
      })
  }
})

export const { actions: getAllFlightItinerariesActions, reducer: getAllFlightItinerariesReducer } =
  getAllFlightItinerariesSlice
export default getAllFlightItinerariesSlice.reducer
